import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class HomeCards {
  $container: JQuery<HTMLElement>;
  $cards: JQuery<HTMLElement>;
  cardsSwiper!: Swiper | null;
  BREAKPOINT: number;

  constructor(el: HTMLElement | JQuery<HTMLElement>) {
    this.$container = $(el);
    this.$cards = this.$container.find('.home-cards__card');
    this.BREAKPOINT = 1024;

    this.init();
  }

  init() {
    this.cardsSwiper = new Swiper(this.$container[0], {
      modules: [Pagination],
      speed: 700,
      spaceBetween: 24,
      centeredSlides: true,
      slidesPerView: 'auto',
      pagination: {
        el: this.$container.find('.swiper-pagination')[0],
        clickable: true,
      },
      breakpoints: {
        [this.BREAKPOINT]: {
          slidesPerView: 3,
          spaceBetween: 20,
          enabled: false,
          centeredSlides: false,
        },
      },
    });
  }
}

export default HomeCards;
